import React from 'react';
import styled from 'styled-components';
import { device, SecondaryColor } from 'GlobalStyles';
import Arrow from 'assets/Arrow.webp';

const ResponsiveSubNavBar = () => {
  const subNavBtns = [
    { question: '컨설팅 준비\n1일차라면?', btnName: 'Frameworks 듣고 보기' },
    { question: '하루만에 컨설팅 인터뷰\n기초를 잡고 싶다면?', btnName: '커리어스텝 기초반 강의' },
    { question: '본격적으로 케이스\n풀기를 시작했다면?', btnName: '케이스 문제 풀어보기' },
    { question: '속성으로 케이스와 핏\n모두 준비하고 싶다면?', btnName: '커리어스텝 실습반 강의' },
    { question: '합격자의 케이스\n해답이 궁금하다면?', btnName: '케이스 노트 연습하기' },
    { question: '곧 면접을 앞두고\n있다면?', btnName: '실전 Mock Interview' },
  ];

  return (
    <StyledContainer>
      {subNavBtns.map(({ question, btnName }) => (
        <BtnRow>
          <QuestionBox>
            <Question>{question}</Question>
            <ArrowImg src={Arrow} />
          </QuestionBox>
          <SubNavBtn>{btnName}</SubNavBtn>
        </BtnRow>
      ))}
    </StyledContainer>
  );
};

export default ResponsiveSubNavBar;

const StyledContainer = styled.nav`
  display: none;

  @media screen and ${device.lg} {
    display: block;
    padding: 0 20px;
  }
`;

const BtnRow = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 0;
`;

const QuestionBox = styled.div`
  position: relative;
  width: 40%;
  border-radius: 5px;
  background-color: #f9f9f9;
  text-align: center;
`;

const Question = styled.div`
  position: relative;
  width: 100%;
  padding: 20px 0;
  background-color: #f9f9f9;
  z-index: 3;
  white-space: pre-wrap;
`;

const ArrowImg = styled.img`
  position: absolute;
  top: 10px;
  right: -10px;
  z-index: 1;
  transform: rotate(-90deg);
`;

const SubNavBtn = styled.li`
  width: 50%;
  text-align: center;
  border: 1px solid #e4e4e4;
  padding: 20px 0;
  font-weight: 700;
  color: ${SecondaryColor};
  list-style: none;
`;
